import {useCatalogMenuStore} from "./store";

export const useCatalogMenu = () => {
    const opened = useCatalogMenuStore(s => s.opened);
    const open = useCatalogMenuStore(s => s.open);
    const close = useCatalogMenuStore(s => s.close);
    const toggle = useCatalogMenuStore(s => s.toggle);

    return {
        opened,
        open,
        close,
        toggle
    };
};
